import { TextInput } from 'src/design/atoms/TextInput';
import React from 'react';
import { ClientGpDto } from 'src/api/FiretrolApiClient';
import { useOrganization } from 'src/hooks/useOrganization';
import { logger } from 'src/utils';

export interface ICustomerSelectorProps {
  customerId: string | null;
  onLoadComplete: (customer: ClientGpDto) => void;
}

export const CustomerSelector: React.FC<ICustomerSelectorProps> = ({
  customerId,
  onLoadComplete,
}) => {
  const [value, setValue] = React.useState<ClientGpDto | null>(null);
  const { clients } = useOrganization();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const loadClient = async () => {
      if (!customerId) return;
      setLoading(true);
      try {
        const client = clients.find((c) => c.custNumber === customerId);
        if (client) {
          setValue(client);
          onLoadComplete(client);
        }
      } catch (err: any) {
        logger.error('Failed to load customer', { err });
      }
      setLoading(false);
    };
    loadClient();
  }, [customerId, clients]);
  return (
    <TextInput
      placeholder={loading ? 'Loading...' : 'Derived from CTC Job'}
      value={value?.custName || ''}
      disabled
    />
  );
};
